import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {GlobalService} from '../../../global.service';
import {EventsService} from '../../events.service';
import {ViewMapComponent} from '../../../Dialogs/view-map/view-map.component';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FacebookService, InitParams} from "ngx-facebook";
import {AppSettings} from '../../../app.settings';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-emotion-cup',
  templateUrl: './emotion-cup.component.html',
  styleUrls: ['./emotion-cup.component.css']
})
export class EmotionCupComponent implements OnInit {
  viewFilters: any;
  game: any;
  city: any;
  language: any;
  emotion_cup_route: any;
  AppSettings: any;

  constructor(private FB: FacebookService, public dialog: MatDialog, private router: Router, public eventService: EventsService, public globalService: GlobalService,
              private titleService:Title) {
    this.titleService.setTitle('emotion-cup')
    this.AppSettings = AppSettings;
    // let initParams: InitParams = {
    //   appId: '1692568150989522',
    //   xfbml: true,
    //   version: "v3.3"
    // };
    //
    // this.FB.init(initParams);
  }

  ngOnInit() {
    this.viewFilters = true;
    // set default language
    if (this.globalService.isBrwoser) {
      if (localStorage.getItem('language')) {
        this.language = require('./lang/' + localStorage.getItem('language') + '.json');
      } else {
        this.language = require('./lang/en.json');
      }
    }
  }

  languageChange(value) {
    if (this.globalService.isBrwoser) {
      this.language = require('./lang/' + value + '.json');
      this.globalService.language = value;
      localStorage.setItem('language', value);
    }
  }

  PinnedLoc(data) {
    this.globalService.pinnedLoc.next(data);
    let dialogRef = this.dialog.open(ViewMapComponent, {
      width: '800px',
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }


  filterByGame(game) {
    if (game != 'Default')
      this.game = game;
    else
      this.game = null;
  }

  filterByCity(city, chosen_city?) {
    this.language.Choose_City = chosen_city;
    if (city != 'Default')
      this.city = city;
    else
      this.city = null;
  }


  openTournament(code, event) {
    if (!event.ctrlKey)
      this.eventService.loadTournaments = true;
  }


}
